import { QuestionModel } from './question.model';

export class SecurityQuestionsModel {
  constructor(public questions: Array<QuestionModel>) {}
}
